

import { Component, Vue, Prop } from "vue-property-decorator";
import moment from 'moment';
import upSkillService from "@/services/upSkillService";
import { Constant } from "@/helpers/constant";
import randomImageService from "@/services/randomImageService";
import { TranslateMalay}  from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";

@Component({
  components: {
   
  },
  props: {
    message: {
      type: String,
      // required: true,
    },
    courseCardData : {},
    courseDetailsData : {}
  },
})
export default class SatelliteEventCard extends Vue {
  testingtext : 'Just testing 999'; 
  courseId:any;
  courseDetails:any;
  $loading:any;
  relatedkeyskils:any;
  sloatDetails:any;
  ratingz:any;
  fullAddress:any;
  venue:any;
  agencyIdValue:any;
  createdByAgency:any;

  selectedLanguage: string='';
  courseListData:any;

  created(){
    this.selectedLanguage = localStorage.getItem("selectedlanguage");
      if(this.selectedLanguage == 'en')
        {
          this.courseListData = TranslateEn.courseListData;
        }
          else
        {
          this.courseListData = TranslateMalay.courseListData;
        }
  }

  relatedCourseDetails(courseId){
    
    this.$router.push("/courseDetails?courseId="+courseId);
    //  this.$router.replace('/courseDetails')
      localStorage.setItem("courseId",courseId)
      this.courseId = courseId;
      //this.getCourseDetails();
      window.scroll(0,0);
  }

  createdBy(id:any) {
     for (let index = 0; index < this.agencyIdValue.length; index++) {
        if(this.agencyIdValue[index] == id){
           this.createdByAgency = true;
        } 
      }
    }


  getCourseDetails() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      id:this.courseId
    };
    upSkillService.getCourseDetails(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.data.statusCode == 200) {
          if (response.data != undefined && response.data != null && response.data.data.data.courses[0] !='' && response.data.data.data.courses[0] != null && response.data.data.data.courses[0] != undefined )
           {
            this.courseDetails = response.data.data.data.courses[0];
            this.relatedkeyskils = this.courseDetails.keySkillId;
            this.sloatDetails= response.data.data.data.courses[0].courseSessions;
            this.ratingz = response.data.data.data.rating;
            if(response.data.data.data.courses[0].courseVenue.length > 0) {
              this.fullAddress = response.data.data.data.courses[0].courseVenue[0].venue[0];
              this.venue = this.fullAddress.address+', '+this.fullAddress.city+', '+this.fullAddress.postcode+', '+this.fullAddress.state;
            }
            this.createdBy(this.courseDetails.createdBy);
            // console.log(this.sloatDetails[0]);
            
             //this.getRelatedCourse();
             
           }else{
             this.courseDetails=[];
           }
        }
      }
    });
  }

  randomImage(){
    return randomImageService.randomImage();
  }

  randomCpImage(){
    return randomImageService.randomCpImage();
  }
  
  // randomPartnersImage(){
  //   return randomImageService.randomPartnersImage();
  // }

  bannerImage(data:any[]){
      // data= this.courseDetails.courseAttachments;
      

      if(data != undefined){
        for (let index = 0; index < data.length; index++) {
        
          if (data[index].fileType == "courseBanner") {
                let url = "";
                
          if (
            data[index].fileUrl != undefined && data[index].fileUrl != null && data[index].fileUrl != ""
          ) {
            url = data[index].fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
          }
      }
      
      }
     
      return null;
          
 }


 formatRating(value) {
    if (value != null) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue)) {
            return numberValue.toFixed(2);
        }
    }
    return '0';
}


formatCurrency(value) {
    if (value != null) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue)) {
            return 'RM ' + numberValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    }
    return 'RM 0.00';
  }

  // getRelatedCourse() {
  //   let loader = this.$loading.show();
  //   let data = {
  //     provider: Constant.JOBSEEKER_PROVIDER,
  //     filter:'',
  //     menu:'',
  //     keyskill:this.relatedkeyskils
  //   };
  //   UpSkillService.gethomeCourseCount(data).then(
  //     (response) => {
  //       loader.hide();


  //       if (response != undefined) {
  //         if (response.data.statusCode == 200) {
  //           if (
  //             response.data != undefined &&
  //             response.data != null 
  //           )
  //          {
  //            let courseArry=[]
  //          this.allCourse =response.data.data.data.courses.data;
  //          for (let index = 0; index < this.allCourse.length; index++) {
  //                if (this.allCourse[index].id != this.courseId) {
  //                   courseArry.push(this.allCourse[index]);
  //                }
  //          }

  //          console.log('get related course')
  //          console.log(courseArry)
  //          console.log('slice get related course')
  //          console.log(courseArry.slice(0,3))
  //          this.relatedCourse = courseArry;
  //          this.courseLength = this.relatedCourse.length;
  //          }
  //         }
  //       }
  //     }
  //   );
  // }



}
